import { render, staticRenderFns } from "./MarketDetails.vue?vue&type=template&id=9190e0ec&"
import script from "./MarketDetails.vue?vue&type=script&lang=js&"
export * from "./MarketDetails.vue?vue&type=script&lang=js&"
import style0 from "./MarketDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports